module.exports = __webpack_public_path__ + "img/register-v2-dark.c488fbc8.svg";